import Vue from 'vue';

const ApiService = {
  get(url) {
    return Vue.prototype.axios({
      method: 'get',
      url,
      headers: {
        'content-type': 'application/x-www-form-urlencoded; application/json; text/plain; charset=utf-8',
      },
    });
  },
  post(url, data) {
    return Vue.prototype.axios({
      method: 'post',
      url: `${url}`,
      headers: {
        'content-type': 'application/x-www-form-urlencoded; application/json; text/plain; charset=utf-8',
      },
      data,
    });
  },
};

export default ApiService;
